module.exports = __webpack_public_path__ + "img/prod-permasense-pswt210.1bbf0104.png";